import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';

interface CallReminderModalProps extends ModalProps {
  onSubmit: () => void;
  message?: string;
}

const CallReminderModal: React.FunctionComponent<CallReminderModalProps> = ({ onClose, onSubmit, open, message }) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSubmit = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  return (
    <Modal
      title={'Message'}
      open={open}
      maxWidth={'xs'}
      onClose={handleClose}
      onSubmit={handleSubmit}
      actions={
        <Button type="submit" color="primary" variant="contained">
          OK
        </Button>
      }
    >
      <p>{message}</p>
    </Modal>
  );
};

export default CallReminderModal;
